// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"b1a729c2","977":"b584b783"}[chunkId] + ".chunk.js";
};